var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.242 44C6.122 44 0 35.82 0 21.927 0 8.063 6.18 0 16.242 0c10.034 0 16.242 8.063 16.242 21.956C32.484 35.792 26.36 44 16.242 44zm0-7.135c4.705 0 7.568-5.134 7.568-14.938 0-9.745-2.891-14.763-7.568-14.763-4.649 0-7.568 5.047-7.568 14.763 0 9.775 2.89 14.938 7.568 14.938zM49.775 24.77v-6.526h4.988c3.884 0 6.52-2.32 6.52-5.743 0-3.365-2.551-5.51-6.548-5.51-3.968 0-6.605 2.29-6.831 5.916h-7.909C40.28 4.99 46.033 0 54.962 0c8.39 0 14.428 4.699 14.428 11.283 0 4.844-2.977 8.614-7.54 9.571v.522c5.612.639 9.127 4.467 9.127 9.978C70.977 38.692 64.23 44 54.905 44 45.778 44 39.6 38.837 39.23 30.948h8.192c.255 3.538 3.175 5.772 7.568 5.772 4.28 0 7.256-2.466 7.256-6.033 0-3.655-2.806-5.917-7.398-5.917h-5.073z",
    fill: "#F2F1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.38743de1c5177865965dcc33f89ca97c.svg";
export { ForwardRef as ReactComponent };